import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const postData = ({ id }) => {
    const url = urlGenerator.message(id)
    return axios.delete(url, createRequestConfig()).then(property('data'))
}

export default postData